import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
// import Public from '../components/Public'
import Login from './Page/Login'
import RequireAuth from './Page/RequireAuth'
import { useEffect, useState } from 'react'
import { GlobalStateContext } from './store/GlobalState'
import Main from './Page/Main'
import Result from './Page/Result'
import ErrorLog from './Page/ErrorLog'
import ManagePermission from './Page/ManagePermission'
//import UsersList from './features/users/UsersList'

function App() {
  const [token, setToken] = useState("")

  let globalState = {
    token: token,
    setToken: setToken,
  }
  useEffect(() => {
    const _token = localStorage.getItem("token")
    if (_token) { // For null, undefined, empty string, etc, this if-condition will be false
      setToken(_token)
    }
  }, [])
  return (
    // <Routes>
    //   <Route path="/" element={<Layout />}>
    //     {/* public routes */}
    //     {/* <Route index element={<Public />} /> */}
    //     <Route path="/" element={<Login />} />

    //     {/* protected routes */}
    //     <Route element={<RequireAuth />}>
    //       <Route path="welcome" element={<Welcome />} />
    //       {/* <Route path="userslist" element={<UsersList />} /> */}
    //     </Route>

    //   </Route>
    // </Routes>
    <GlobalStateContext.Provider value={globalState}>
      {/* <Router> */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/main" element={<Main />} />
        <Route path="/result" element={<Result />} />
        <Route path="/errorLog" element={<ErrorLog />} />
        <Route path="/managePermission" element={<ManagePermission />} />

      </Routes>
      {/* </Router> */}
    </GlobalStateContext.Provider>
  )
}

export default App;